import React, { useState } from "react";
import "../css/Header2.css";

const Header2 = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="header2-wrapper">

      {/* Top White Quote Bar */}
      <div className="header2-quote">
        We're all strong on this planet
      </div>

      {/* Main Header */}
      <header className="header2">

        {/* Hamburger - visible on mobile */}
        <div
          className={`header2-hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Left Nav */}
        <nav className="header2-left desktop-nav">
          <a href="/">Home</a>
          <a href="/workouts">Workout</a>
          <a href="/plans">Pricing</a>
          <a href="/services">Services</a>
        </nav>

        {/* Center Brand */}
        <div className="header2-logo">FLEXOR</div>

        {/* Right Nav */}
        <nav className="header2-right desktop-nav">
          <a href="/gallery">Gallery</a>
          <a href="/trainers">Trainers</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          <a href="/faqs">FAQs</a>
        </nav>

        {/* MOBILE MENU */}
        <div className={`header2-mobile-menu ${menuOpen ? "show" : ""}`}>
          <a href="/" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="/workouts" onClick={() => setMenuOpen(false)}>Workout</a>
          <a href="/plans" onClick={() => setMenuOpen(false)}>Pricing</a>
          <a href="/services" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="/gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
          <a href="/trainers" onClick={() => setMenuOpen(false)}>Trainers</a>
          <a href="/about" onClick={() => setMenuOpen(false)}>About</a>
          <a href="/contact" onClick={() => setMenuOpen(false)}>Contact</a>
          <a href="/faqs" onClick={() => setMenuOpen(false)}>FAQs</a>
        </div>

      </header>

    </div>
  );
};

export default Header2;
